const FacilityPagination = ({ total, page, totalPages, limit, onPageChange, onLimitChange }) => (
  <div className="flex flex-nowrap items-center justify-between gap-2 whitespace-nowrap text-sm">
    <span>Total {total}</span>

    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        Rows per page
        <select
          value={limit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          className="rounded-md border px-2 py-1"
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={30}>30</option>
        </select>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={page <= 1 || total === 0}
          onClick={() => onPageChange(page - 1)}
          className="px-1 text-base leading-none sm:px-2.5 sm:py-0.5 sm:text-2xl disabled:opacity-50"
        >
          &lsaquo;
        </button>

        <span>{total === 0 ? "0 / 0" : `${page} / ${totalPages}`}</span>

        <button
          type="button"
          disabled={page >= totalPages || total === 0}
          onClick={() => onPageChange(page + 1)}
          className="px-1 text-base leading-none sm:px-2.5 sm:py-0.5 sm:text-2xl disabled:opacity-50"
        >
          &rsaquo;
        </button>
      </div>
    </div>
  </div>
);

export default FacilityPagination;
